function getConfigInternal() {
    if ("zebDshAppFrameConfig" in window) {
        const config = window.zebDshAppFrameConfig; // global variable zebDshAppFrameConfig is initialized by server injected script that already finished
        if (config == null) {
            return null;
        }
        else {
            return config;
        }
    }
    else {
        return null;
    }
}
export function getConfig() {
    const config = getConfigInternal();
    if (config == null) {
        console.error("[zebdshappframe] configuration not available");
        return {};
    }
    else {
        return config;
    }
}
